import { createAction, props } from '@ngrx/store';
import { Params } from '@angular/router';
import {
  Feedback,
  FeedbackCategory,
  FeedbackResponse,
} from './feedback.interface';

// Get Feedback List
export const getFeedbacks = createAction(
  '[Feedback] Get Feedbacks',
  props<{ params?: any }>(),
);

export const getFeedbacksSuccess = createAction(
  '[Feedback] Get Feedbacks Success',
  props<{ feedbacks: FeedbackResponse }>(),
);

export const getFeedbacksFailure = createAction(
  '[Feedback] Get Feedbacks Failure',
  props<{ error: any }>(),
);

export const updateFeedbackParams = createAction(
  '[Feedback] Update Feedback Params',
  props<{ params: Params }>(),
);

// Get Feedback by ID
export const getFeedbackById = createAction(
  '[Feedback API] Get Feedback By Id',
  props<{ id: number }>(),
);

export const getFeedbackByIdSuccess = createAction(
  '[Feedback API] Get Feedback By Id Success',
  props<{ feedback: Feedback }>(),
);

export const getFeedbackByIdFailure = createAction(
  '[Feedback API] Get Feedback By Id Failure',
  props<{ error: any }>(),
);

export const clearFeedbackDetails = createAction(
  '[Feedback API] Clear Feedback Details',
);

// Post Feedback
export const addFeedback = createAction(
  '[Feedback API] Add Feedback',
  props<{ payload: any }>(),
);

export const addFeedbackSuccess = createAction(
  '[Feedback API] Add Feedback Success',
  props<{ feedback: Feedback }>(),
);

export const addFeedbackFailure = createAction(
  '[Feedback API] Add Feedback Failure',
  props<{ error: any }>(),
);

export const resetAddFeedbackSuccess = createAction(
  '[Feedback] Reset Add Feedback Success',
);

// Update Feedback
export const updateFeedback = createAction(
  '[Feedback API] Update Feedback',
  props<{ id: number; payload: any }>(),
);

export const updateFeedbackSuccess = createAction(
  '[Feedback API] Update Feedback Success',
  props<{ feedback: Feedback }>(),
);

export const updateFeedbackFailure = createAction(
  '[Feedback API] Update Feedback Failure',
  props<{ error: any }>(),
);

// Feedback Categories
export const getFeedbackCategories = createAction(
  '[Feedback API] Get Feedback Categories',
  props<{ params?: any }>(),
);

export const getFeedbackCategoriesSuccess = createAction(
  '[Feedback API] Get Feedback Categories Success',
  props<{ categories: any }>(),
);

export const getFeedbackCategoriesFailure = createAction(
  '[Feedback API] Get Feedback Categories Failure',
  props<{ error: any }>(),
);
